import * as React from 'react';
import { Textarea as ChakraTextarea, TextareaProps } from '@chakra-ui/react';
import { withConfirm } from '../withConfirm';
import { CustomFormControl, DirectionProp } from '../CustomFormControl';

interface IProps extends DirectionProp {
  id?: string;
  name?: string;
  value?: string | null;
  label?: string | React.ReactNode;
  subText?: string;
  note?: string;
  type?: string;
  autoFocus?: boolean;
  showDescription?: boolean;
  showErrorText?: boolean; // for components that inherent this one
  inputHelperText?: string;
  errorText?: string;
  forwardedRef?:
    | ((instance: HTMLTextAreaElement | null) => void)
    | React.RefObject<HTMLTextAreaElement>
    | null
    | undefined;
  onChange?: (event: React.FormEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FormEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.FormEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  shouldAutoResize?: boolean;
  disabled?: boolean;
  size?: 'lg' | 'md' | 'sm';
  mb?: number | string;
  mt?: number | string;
  textareaProps?: TextareaProps;
}

const Textarea: React.FC<IProps> = (props: IProps) => {
  const {
    id = 'multi-line-input',
    name = 'multi-line-input',
    errorText,
    shouldAutoResize = true,
    size = 'lg',
    mb = 0,
    mt = 0,
    direction,
    textareaProps,
    ...otherProps
  } = props;

  const autoResize = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (!shouldAutoResize) {
      return;
    }
    const element = event.currentTarget as HTMLTextAreaElement;
    element.style.height = '80px';
    element.style.height = element.scrollHeight + 'px';
  };

  return (
    <CustomFormControl
      id={id}
      controlProps={{
        isInvalid: errorText ? true : false,
        mb,
        mt
      }}
      direction={direction}
      size={size}
      label={otherProps.label}
      labelProps={{ htmlFor: `${id}-input-field` }}
      subLabel={otherProps.subText}
      helperText={otherProps.note}
      error={errorText}
    >
      <ChakraTextarea
        id={`${id}-input-field`}
        name={name}
        data-selector={`${id}-input-field`}
        aria-label={otherProps.placeholder && !otherProps.label ? otherProps.placeholder : null}
        onChange={otherProps.onChange}
        value={otherProps.value}
        autoFocus={otherProps.autoFocus}
        ref={otherProps.forwardedRef}
        onBlur={otherProps.onBlur}
        onFocus={otherProps.onFocus}
        onKeyUp={event => autoResize(event)}
        placeholder={otherProps.placeholder}
        isDisabled={otherProps.disabled}
        size={size}
        lineHeight={6}
        transition="height none"
        {...textareaProps}
      />
    </CustomFormControl>
  );
};

const TextareaWithConfirm = withConfirm(Textarea);

export { Textarea, TextareaWithConfirm };
